import { createFileRoute } from "@tanstack/react-router";
import CausaDetalhe from "@/pages/CausaDetalhe";
import { institutionWithStatsQueryOptions } from "@/hooks/useInstitutionStats";
import { seoHead } from "@/lib/seoHead";

interface CausaSeo {
  name?: string | null;
  description?: string | null;
  cover_url?: string | null;
  logo_url?: string | null;
  seo?: { titulo?: string | null; descricao?: string | null; imagem_compartilhamento?: string | null } | null;
}

export const Route = createFileRoute("/causa/$slug")({
  loader: async ({ params, context }) => {
    try {
      // Pré-carrega no servidor a mesma consulta da página (mesma chave de
      // cache), então a causa já chega renderizada no HTML.
      const inst = await context.queryClient.ensureQueryData(
        institutionWithStatsQueryOptions(params.slug),
      );
      return { institution: (inst ?? null) as CausaSeo | null };
    } catch {
      return { institution: null };
    }
  },
  // Mesmos valores do usePageSeo da página, agora renderizados no servidor.
  head: ({ loaderData, params }) => {
    const inst = loaderData?.institution;
    return seoHead({
      title:
        inst?.seo?.titulo ||
        (inst?.name ? `${inst.name} | Shopping do Bem` : "Causa | Shopping do Bem"),
      description:
        inst?.seo?.descricao ||
        inst?.description ||
        "Apoie esta causa fazendo suas compras pelo Shopping do Bem.",
      path: `/causa/${params.slug}`,
      ogImage: inst?.seo?.imagem_compartilhamento || inst?.cover_url || inst?.logo_url || null,
    });
  },
  component: CausaDetalhe,
});
